import React from "react";
import { Typography, Grid, TextField, InputAdornment } from "@mui/material";
import { handleMobileKeyDown } from "../globals/utils";

export default function FarmerDetailsForm(data, setData) {
  const onChange = (event) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };

  return (
    <Grid container spacing={2}>
      <Grid item>
        <Typography variant="subtitle1">Farmer Details</Typography>
      </Grid>
      <Grid item xs={12}>
        <TextField
          variant="outlined"
          fullWidth
          label="Mobile Number"
          name="mobile_number"
          onChange={onChange}
          type="tel"
          inputProps={{
            maxLength: 10,
            inputMode: "numeric",
          }}
          onKeyDown={handleMobileKeyDown}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">+91</InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          variant="outlined"
          fullWidth
          label="PAN"
          name="pan"
          onChange={onChange}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          variant="outlined"
          fullWidth
          label="Address"
          multiline
          rows={4}
          name="address"
          onChange={onChange}
        />
      </Grid>
      <Grid item xs={12}>
        Upload Aadhar
        <input
          type="file"
          name="canceledCheque"
          multiple
          // onChange={onFileChange}
        />
      </Grid>
    </Grid>
  );
}
